import { useMutation } from "@tanstack/react-query";
import { getProducts, renewSubscription } from "../services/apiSubscription";
import { useMappedQuery } from "./queryUtils";

export function useProducts() {
  return useMappedQuery({
    queryKey: ["products"],
    queryFn: getProducts,
  });
}

export function useRenewSubscription() {
  return useMutation({
    mutationFn: renewSubscription,
  });
}
